import { useCreateStateV2DSMutation } from "../../core/api/ds-state-api"
import {
    useGetSyncConflictDSQuery,
    useGetSyncConflictsDSQuery
} from "../../core/api/ds-sync-conflicts-api"
import SyncConflictsPage from "./SyncConflictsPage"

export default function SyncConflictsDS({ game = "ds" }) {
    const [createState, createStateResult] = useCreateStateV2DSMutation()

    return (
        <SyncConflictsPage
            game={game}
            useListQuery={useGetSyncConflictsDSQuery}
            useDetailQuery={useGetSyncConflictDSQuery}
            createState={createState}
            createStateResult={createStateResult}
        />
    )
}
